var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DashboardLayout',[_c('UsersBody',{attrs:{"users":_vm.users.paginatedusers,"page":_vm.users.userpage,"loading":_vm.users.loading,"userCount":_vm.users.userCount,"filter":_vm.users.filter}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }